
  import VueSlickCarousel from 'vue-slick-carousel'
  
  export default {
    props: {
      blok: {
        type: Object,
        default: () => {}
      }
    },
    // mounted() {
    //   this.resize()
    //   window.addEventListener('resize',this.resize)
    // },
    // destroyed() {
    //   window.removeEventListener('resize',this.resize)
    // },
    data() {
      return  {
        activeSlide: 0,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 1,
          autoplay: false,
          autoplaySpeed: 7000,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                arrows: true,
                slidesToShow: 1
              }
            }
          ]
        }
      }
    },
    methods: {
      change(e, i) {
        this.activeSlide = i
      },
      resize() {
        // match card height
        // setTimeout(function() {
        //   let promoBodies = document.querySelectorAll('.image-slider.card>div:last-of-type')
        //   let tallest = 200
        //   for (var i = promoBodies.length - 1; i >= 0; i--) {
        //     if (tallest < promoBodies[i].offsetHeight) {
        //       tallest = promoBodies[i].offsetHeight
        //     }
        //   }
        //   for (var i = promoBodies.length - 1; i >= 0; i--) {
        //     promoBodies[i].style.minHeight = tallest+'px'
        //   }
        // }, 500)
      }
    },
    components: {
      VueSlickCarousel,
    },
  }
  